import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export type MenuItem = {
  label: string,
  onClick?: (item: MenuItem, index: number) => any,
  divider?: boolean,
  heading?: boolean,
  classList?: string
};

export type SelectionEvent = {
  item: MenuItem,
  index: number
};

@Component({
  selector: 'menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
  @Input() items: MenuItem[] = [];
  @Input() selectedIndex: number = -1;
  @Output() selection: EventEmitter<SelectionEvent> = new EventEmitter();
  onSelection(item: MenuItem, index: number): void {
    if (typeof item.onClick === 'function') {
      item.onClick(item, index);
    }
    this.selectedIndex = index;
    this.selection.emit({item: item, index: index});
  }
}
